export default __webpack_public_path__ + "static/swvl-3-62eb0749e31f078c714b6f2be948e892.webp";